/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
/**
 * DRY util for rendering an option with its prepend and append properties
 */
export var EuiComboBoxOptionAppendPrepend = function EuiComboBoxOptionAppendPrepend(_ref) {
  var children = _ref.children,
    option = _ref.option,
    classNamePrefix = _ref.classNamePrefix;
  return ___EmotionJSX(React.Fragment, null, (option === null || option === void 0 ? void 0 : option.prepend) && ___EmotionJSX("span", {
    className: "".concat(classNamePrefix, "__prepend")
  }, option.prepend), children, (option === null || option === void 0 ? void 0 : option.append) && ___EmotionJSX("span", {
    className: "".concat(classNamePrefix, "__append")
  }, option.append));
};